import { render, staticRenderFns } from "./addRubric.vue?vue&type=template&id=07fa97a2&lang=html&"
import script from "./addRubric.vue?vue&type=script&lang=ts&"
export * from "./addRubric.vue?vue&type=script&lang=ts&"
import style0 from "./addRubric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports